import { useState } from 'react';
import Modal from './Modal';

function LanguageSelector({ currentLang, onLanguageChange }) {
  const [showModal, setShowModal] = useState(false);

  const handleEnglishClick = () => {
    setShowModal(true);
  };

  return (
    <>
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onLanguageChange('ko')}
          className={`px-3 py-1 rounded-md ${
            currentLang === 'ko'
              ? 'bg-primary text-white'
              : 'bg-white text-primary hover:bg-gray-100'
          }`}
        >
          KO
        </button>
        <button
          onClick={handleEnglishClick}
          className={`px-3 py-1 rounded-md ${
            currentLang === 'en'
              ? 'bg-primary text-white'
              : 'bg-white text-primary hover:bg-gray-100'
          }`}
        >
          EN
        </button>
      </div>

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      >
        <div className="text-center">
          <h3 className="text-xl font-bold text-primary mb-4">
            준비 중입니다
          </h3>
          <p className="text-gray-600 mb-6">
            영어 버전은 현재 준비 중입니다.<br />
            조금만 기다려 주세요.
          </p>
          <button
            onClick={() => setShowModal(false)}
            className="px-4 py-2 bg-primary text-white rounded-md hover:bg-secondary transition-colors duration-300"
          >
            확인
          </button>
        </div>
      </Modal>
    </>
  );
}

export default LanguageSelector; 